import { useTranslation } from "react-i18next";
import { img } from "../../constants/assets";
import LegalPageLayout from "../../components/LegalPageLayout";

const navConfig = [
  { id: "introduction", labelKey: "privacy.nav.introduction", icon: "terms1.svg" },
  {
    id: "data-collection",
    labelKey: "privacy.nav.dataCollection",
    icon: "terms2.svg",
  },
  {
    id: "information-use",
    labelKey: "privacy.nav.informationUse",
    icon: "tems3.svg",
  },
  {
    id: "data-security",
    labelKey: "privacy.nav.dataSecurity",
    icon: "terms4.svg",
  },
  { id: "contact-us", labelKey: "privacy.nav.contactUs", icon: "terms5.svg" },
];

function PrivacyPolicy() {
  const { t } = useTranslation();
  const collectionItems = t("privacy.dataCollection.items", { returnObjects: true });
  const useCards = t("privacy.informationUse.cards", { returnObjects: true });

  const navItems = navConfig.map((item) => ({
    id: item.id,
    label: t(item.labelKey),
    icon: item.icon,
  }));

  return (
    <LegalPageLayout
      title={t("privacy.title")}
      lastUpdated="2023-10"
      navItems={navItems}
      navAriaLabel={t("privacy.navAriaLabel")}
    >
      <section id="introduction" className="legal-section">
        <h2 className="legal-section-title">{t("privacy.introduction.title")}</h2>
        <p className="legal-text">{t("privacy.introduction.p1")}</p>
        <p className="legal-text">{t("privacy.introduction.p2")}</p>
      </section>

      <section id="data-collection" className="legal-section">
        <h2 className="legal-section-title">{t("privacy.dataCollection.title")}</h2>
        <p className="legal-text">{t("privacy.dataCollection.intro")}</p>
        <ul className="legal-list">
          {collectionItems.map((item) => (
            <li key={item.label}>
              <strong>{item.label}:</strong> {item.text}
            </li>
          ))}
        </ul>
      </section>

      <section id="information-use" className="legal-section">
        <h2 className="legal-section-title">{t("privacy.informationUse.title")}</h2>
        <p className="legal-text">{t("privacy.informationUse.intro")}</p>
        <div className="legal-cards">
          {useCards.map((card) => (
            <article className="legal-card" key={card.title}>
              <h3 className="legal-card-title">{card.title}</h3>
              <p className="legal-card-text">{card.text}</p>
            </article>
          ))}
        </div>
      </section>

      <section id="data-security" className="legal-section">
        <h2 className="legal-section-title">{t("privacy.dataSecurity.title")}</h2>
        <div className="legal-image-wrap">
          <img
            src={img("terms&condition.svg")}
            alt={t("privacy.dataSecurity.imageAlt")}
          />
          <p className="legal-image-caption">
            {t("privacy.dataSecurity.imageCaption")}
          </p>
        </div>
        <p className="legal-text">{t("privacy.dataSecurity.p1")}</p>
      </section>

      <section id="contact-us" className="legal-section">
        <h2 className="legal-section-title">{t("privacy.contactUs.title")}</h2>
        <p className="legal-text">{t("privacy.contactUs.p1")}</p>
      </section>
    </LegalPageLayout>
  );
}

export default PrivacyPolicy;
